import { render, staticRenderFns } from "./CreateBankTransfer.vue?vue&type=template&id=0a5dd2e2&"
import script from "./CreateBankTransfer.vue?vue&type=script&lang=ts&"
export * from "./CreateBankTransfer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a5dd2e2')) {
      api.createRecord('0a5dd2e2', component.options)
    } else {
      api.reload('0a5dd2e2', component.options)
    }
    module.hot.accept("./CreateBankTransfer.vue?vue&type=template&id=0a5dd2e2&", function () {
      api.rerender('0a5dd2e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cash-management/bank-transfer/CreateBankTransfer.vue"
export default component.exports